/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable radix */
/* eslint-disable no-shadow */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import {
  useState, useRef, useEffect, useMemo,
} from 'react';
import {
  Box, NumberInput, Text, useMantineColorScheme, RangeSlider,
} from '@mantine/core';
import { X } from 'tabler-icons-react';
import { assetPrefix } from '../../../utilities/general';
import NewCustomPopover from './NewCustomPopover';
import NewRangePopoverContent from './NewRangePopoverContent';

const CustomPercentageField = ({
  value,
  defaultLabel,
  setValue,
  title,
  popoverOpenRef,
  originalData,
  parentKey,
  childKey,
  multiplyBy100,
}) => {
  const [min, setMin] = useState(null);
  const [max, setMax] = useState(null);
  const [tempMin, setTempMin] = useState(0);
  const [tempMax, setTempMax] = useState(0);
  const [range, setRange] = useState('');
  const [minError, setMinError] = useState('');
  const [maxError, setMaxError] = useState('');
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [hasValidated, setHasValidated] = useState(false);

  const { colorScheme } = useMantineColorScheme();
  const numberInputHandlersRef = useRef();

  const maxTotal = useMemo(() => {
    if (!originalData || originalData.length === 0) return 100;

    return originalData.reduce((max, item) => {
      let value = childKey ? item?.[parentKey]?.[childKey] : item?.[parentKey];

      if (value == null) return max;

      value = multiplyBy100 ? value * 100 : value;

      const currentMax = (max === null || value > max) ? value : max;

      if (currentMax == null) return 100;

      return Number.isInteger(currentMax) ? currentMax : Math.ceil(currentMax) + 1;
    }, null) || 100;
  }, [originalData, parentKey, childKey, multiplyBy100]);

  const minTotal = useMemo(() => {
    if (!originalData || originalData.length === 0) return -100;

    return originalData.reduce((min, item) => {
      let value = childKey ? item?.[parentKey]?.[childKey] : item?.[parentKey];

      if (value == null) return min;

      value = multiplyBy100 ? value * 100 : value;

      const currentMin = (min === null || value < min) ? value : min;

      if (currentMin == null) return -100;

      return Number.isInteger(currentMin) ? currentMin : Math.floor(currentMin) - 1;
    }, null) || -100;
  }, [originalData, parentKey, childKey, multiplyBy100]);

  useEffect(() => {
    if (!value || !Array.isArray(value) || value.length !== 2) {
      setMin(null);
      setMax(null);
      setTempMin(minTotal || -100);
      setTempMax(maxTotal || 100);
      setRange('');
      setMinError('');
      setMaxError('');
      setHasValidated(false);
    } else {
      setMin(value[0]);
      setMax(value[1]);
      setTempMin(value[0]);
      setTempMax(value[1]);
      setRange(`${value[0]}% - ${value[1]}%`);
    }
  }, [value, minTotal, maxTotal]);

  useEffect(() => {
    if (isPopoverOpen) {
      setTempMin(min !== null ? min : minTotal || -100);
      setTempMax(max !== null ? max : maxTotal || 100);
      setMinError('');
      setMaxError('');
    }
  }, [isPopoverOpen, min, max, minTotal, maxTotal]);

  useEffect(() => {
    if (popoverOpenRef) {
      popoverOpenRef.current = isPopoverOpen;
    }
  }, [isPopoverOpen, popoverOpenRef]);

  const validateValues = (minVal, maxVal, showErrors = false) => {
    let isValid = true;
    const parsedMin = minVal === '' ? undefined : parseFloat(minVal);
    const parsedMax = maxVal === '' ? undefined : parseFloat(maxVal);

    if (parsedMin === undefined) {
      if (showErrors) setMinError('Minimum is required');
      isValid = false;
    } else if (parsedMin < minTotal) {
      if (showErrors) setMinError(`Minimum cannot be less than ${minTotal}%`);
      isValid = false;
    } else if (showErrors) {
      setMinError('');
    }

    if (parsedMax === undefined) {
      if (showErrors) setMaxError('Maximum is required');
      isValid = false;
    } else if (parsedMax > maxTotal) {
      if (showErrors) setMaxError(`Maximum cannot be greater than ${maxTotal}%`);
      isValid = false;
    } else if (showErrors) {
      setMaxError('');
    }

    if (parsedMin !== undefined && parsedMax !== undefined && parsedMin > parsedMax) {
      if (showErrors) {
        setMinError('Minimum cannot be greater than Maximum');
        setMaxError('Maximum cannot be less than Minimum');
      }
      isValid = false;
    }

    return isValid;
  };

  const confirmSelection = () => {
    const isValid = validateValues(tempMin, tempMax, true);
    setHasValidated(true);
    if (!isValid) return;

    const parsedMin = parseFloat(tempMin);
    const parsedMax = parseFloat(tempMax);

    setMin(parsedMin);
    setMax(parsedMax);
    setRange(`${parsedMin}% - ${parsedMax}%`);
    setValue([parsedMin, parsedMax]);
    setIsPopoverOpen(false);
  };

  const clearSelection = () => {
    setMin(null);
    setMax(null);
    setTempMin(minTotal || -100);
    setTempMax(maxTotal || 100);
    setRange('');
    setValue(null);
    setMinError('');
    setMaxError('');
    setHasValidated(false);
    setIsPopoverOpen(false);
  };

  const handleClosePopover = () => {
    setIsPopoverOpen(false);
    setTempMin(min !== null ? min : minTotal || -100);
    setTempMax(max !== null ? max : maxTotal || 100);
    setMinError('');
    setMaxError('');
  };

  // const displayValueOfSelectedRange = useMemo(() => {
  //   if (!range) return null;
  //   return (
  //     <div className="inline-flex items-center px-2 text-md font-medium rounded-2xl whitespace-nowrap bg-[#E0F7FA] text-[#00796B]">
  //       {range}
  //     </div>
  //   );
  // }, [range]);

  const displayValueOfSelectedRange = useMemo(() => {
    if (!range) return null;

    // Parse the min and max values from the range string
    const [minValue, maxValue] = range.split(' - ').map((val) => parseInt(val));

    return (
      <div className="inline-flex items-center px-2 text-md font-medium rounded-2xl whitespace-nowrap dark:bg-slate-500 bg-[#E0F7FA]">
        <div
          className={`${minValue < 0 ? 'text-[#FF0000]' : 'text-[#39B118]'}`}
        >
          {`${minValue}%`}
        </div>
        <div className="px-1">-</div>
        <div
          className={`${maxValue < 0 ? 'text-[#FF0000]' : 'text-[#39B118]'}`}
        >
          {`${maxValue}%`}
        </div>
      </div>
    );
  }, [range]);

  return (
    <NewCustomPopover
      opened={isPopoverOpen}
      onChange={setIsPopoverOpen}
      position="bottom-start"
      width={300}
      shadow="md"
      target={(
        <Box className={`flex flex-col border-b ${colorScheme === 'dark' && 'border-neutral-600'} gap-3 pb-5`}>
          <div className="flex justify-between font-bold">
            <div>{title}</div>
            {displayValueOfSelectedRange}
          </div>

          <Box
            onClick={() => setIsPopoverOpen(true)}
            className={`flex items-center justify-between gap-1 border rounded-md h-12 px-1.5 py-1 cursor-pointer 
              ${colorScheme === 'dark' ? 'border-[#737373] bg-[#1E1E1E]' : 'border-[#E8E8E8] bg-white'}`}
          >
            <Text>
              {range ? (
                <div className={`inline-flex items-center px-2 ${colorScheme === 'dark' ? 'bg-[#1E293B] text-[#F4F4F5]' : 'bg-[#EEF4FF] text-[#2E2E2E]'} text-md font-medium rounded-2xl whitespace-nowrap`}>
                  {range}
                </div>
              ) : (
                <div className="inline-flex items-center px-2 text-[#898989] text-md font-medium rounded-2xl whitespace-nowrap">
                  {defaultLabel}
                </div>
              )}
            </Text>

            <div className="flex gap-2 ml-1 items-center">
              <img className="w-3 h-3" src={`${assetPrefix}/images/DownArrow.svg`} alt="downarrow" />
              <X
                size={16}
                onClick={(e) => {
                  e.stopPropagation();
                  clearSelection();
                }}
                className="text-gray-500 mr-1 cursor-pointer"
              />
            </div>
          </Box>
        </Box>
      )}
      dropdown={(
        <div className="relative p-2">
          <Box
            className="cursor-pointer absolute -top-2 -right-6"
            onClick={handleClosePopover}
          >
            <X size={18} color="#898989" />
          </Box>
          <Box className="mb-7 mt-5" w={230}>
            <RangeSlider
              styles={{
                track: {
                  height: 6,
                },
                bar: {
                  backgroundColor: '#33B1FF',
                },
                thumb: {
                  backgroundColor: '#33B1FF',
                  border: 'none',
                  color: '#33B1FF',
                },
                markFilled: {
                  border: 'none',
                  backgroundColor: 'none',
                },
                markLabel: {
                  color: colorScheme === 'dark' ? '#fff' : 'black',
                  marginTop: 15,
                },
                mark: {
                  border: 'none',
                  backgroundColor: 'none',
                  display: 'none',
                },
                markWrapper: {
                  color: colorScheme === 'dark' ? '#fff' : 'black',
                },
                label: {
                  backgroundColor: '#33B1FF',
                  color: '#fff',
                  fontSize: 12,
                  height: 'auto',
                  padding: '2px 6px',
                  borderRadius: 4,
                  top: -32,
                  fontWeight: 500,
                },
              }}
              min={minTotal || -100}
              max={maxTotal || 100}
              step={1}
              value={[parseFloat(tempMin), parseFloat(tempMax)]}
              marks={[
                { value: minTotal || -100, label: `${minTotal || -100}%` },
                { value: maxTotal || 100, label: `${maxTotal || 100}%` },
              ]}
              onChange={([minVal, maxVal]) => {
                setTempMin(minVal);
                setTempMax(maxVal);
                if (hasValidated) validateValues(minVal, maxVal, true);
              }}
            />
          </Box>

          <NewRangePopoverContent
            onConfirm={confirmSelection}
            onClear={clearSelection}
          // onClose={handleClosePopover}
          >
            <NumberInput
              placeholder={`Minimum (${minTotal || -100}% - ${maxTotal || 100}%)`}
              value={tempMin}
              min={minTotal || -100}
              max={maxTotal || 100}
              onChange={(val) => {
                setTempMin(val !== undefined ? val : minTotal || -100);
                if (hasValidated) validateValues(val, tempMax, true);
              }}
              error={minError}
              parser={(val) => val
                // .replace(/[^0-9.]/g, '')
                // .replace(/^\.*/, '')
                // .replace(/(\..*)\./g, '$1')}
                .replace(/[^0-9.-]/g, '')
                .replace(/(?!^)-/g, '')
                .replace(/(\..*)\./g, '$1')}
              precision={2}
              handlersRef={numberInputHandlersRef}
              rightSection={(
                <div className="flex flex-col justify-center gap-2 pr-1">
                  <div onClick={() => numberInputHandlersRef.current?.increment()}>
                    <img src={`${assetPrefix}/images/upArrow.svg`} alt="uparrow" className="cursor-pointer" />
                  </div>
                  <div onClick={() => numberInputHandlersRef.current?.decrement()}>
                    <img src={`${assetPrefix}/images/DownArrow.svg`} alt="downarrow" className="cursor-pointer" />
                  </div>
                </div>
              )}
              rightSectionWidth={28}
              hideControls
              radius={6}
              classNames={{
                input: `${colorScheme === 'dark' ? 'bg-[#1a1b1e] border-[#737373] text-white' : ''}`,
              }}
            />

            <NumberInput
              placeholder={`Maximum (${minTotal || -100}% - ${maxTotal || 100}%)`}
              value={tempMax}
              min={minTotal || -100}
              max={maxTotal || 100}
              onChange={(val) => {
                setTempMax(val !== undefined ? val : maxTotal || 100);
                if (hasValidated) validateValues(tempMin, val, true);
              }}
              parser={(val) => val
                // .replace(/[^0-9.]/g, '')
                // .replace(/^\.*/, '')
                // .replace(/(\..*)\./g, '$1')}
                .replace(/[^0-9.-]/g, '')
                .replace(/(?!^)-/g, '')
                .replace(/(\..*)\./g, '$1')}
              error={maxError}
              precision={2}
              handlersRef={numberInputHandlersRef}
              rightSection={(
                <div className="flex flex-col justify-center gap-2 pr-1">
                  <div onClick={() => numberInputHandlersRef.current?.increment()}>
                    <img src={`${assetPrefix}/images/upArrow.svg`} alt="uparrow" className="cursor-pointer" />
                  </div>
                  <div onClick={() => numberInputHandlersRef.current?.decrement()}>
                    <img src={`${assetPrefix}/images/DownArrow.svg`} alt="downarrow" className="cursor-pointer" />
                  </div>
                </div>
              )}
              rightSectionWidth={28}
              hideControls
              radius={6}
              classNames={{
                input: `${colorScheme === 'dark' ? 'bg-[#1a1b1e] border-[#737373] text-white' : ''}`,
              }}
            />
          </NewRangePopoverContent>
        </div>
      )}
      dropdownClassName={`h-auto w-[264px] px-[29px] pt-4 pb-4 ${colorScheme === 'dark' ? 'bg-[#1a1b1e]' : ''} rounded-md`}
    />
  );
};

export default CustomPercentageField;
